<template>
  <div v-if="email && project && (projectStatuses.length > 0)">
    <v-speed-dial v-if="permit.canCreateTicket(project)"
      v-model="fab"
      bottom right fixed open-on-hover
      direction="top"
      transition='slide-y-reverse-transition'
      >
      <v-btn
        slot="activator"
        v-model="fab"
        color="#0155a8"
        dark
        fab
        fixed
        >
        <v-icon>add</v-icon>
        <v-icon>close</v-icon>
      </v-btn>

      <v-tooltip
        bottom
        color="#fff"
        >
        <v-btn fab
          color="#00E676"
          small
          slot="activator"
          @click="newTicket = !newTicket"
          >
          <v-icon small color="white">local_play</v-icon>
        </v-btn>
        <span class="black--text">Create new ticket</span>
      </v-tooltip>

      <v-tooltip
        bottom
        color="#fff"
        >
        <v-btn fab
          color="#3a9cfc"
          small
          slot="activator"
          @click="linkTicket = !linkTicket"
          >
          <v-icon small color="white">link</v-icon>
        </v-btn>
        <span class="black--text">Link to ticket</span>
      </v-tooltip>
    </v-speed-dial>

    <v-card class="mb-3 sticky-element" :class="stickyClass">
      <v-layout row wrap justify-space-between class="pa-2">
        <v-flex xs12 class="grey--text">
          <h1 class="grey--text text--darken-2 text-truncate text-nowrap text-xs-center text-md-left pa-2">
            {{email.attributes.subject}}
          </h1>
        </v-flex>
      </v-layout>

      <v-layout row wrap class="pt-2">
        <v-flex xs4 sm3 md2 lg2 class="text-uppercase text-xs-right pr-3">Received on</v-flex>
        <v-flex xs8 sm9 md4 lg2>
          {{ email.attributes.created_at | formatDateAgo }} on {{ email.attributes.created_at | formatDateLong}}
        </v-flex>

        <v-flex xs4 sm3 md2 lg2 class="text-uppercase text-xs-right pr-3">From</v-flex>
        <v-flex xs8 sm9 md4 lg2>
          {{ email.attributes.from }}
        </v-flex>
      </v-layout>

      <v-layout row wrap class="pt-2" v-if="tickets.length > 0">

        <v-flex xs4 sm3 md2 lg2 class="text-uppercase text-xs-right pr-3 pt-2" v-if="tickets.length > 0">Linked tickets</v-flex>
        <v-flex xs8 sm9 md4 lg2 v-if="tickets.length > 0">
          <span v-for="(tck, idx) in tickets" :key="idx">
            <v-tooltip bottom>
              {{tck.attributes.title}}
              <v-chip disabled small outline slot="activator">
                <a :href="tck.links.project_show_uri" target="tickets">
                  # {{tck.attributes.sequential_id}}
                </a>
              </v-chip>
            </v-tooltip>
          </span>
        </v-flex>
      </v-layout>

      <v-layout row wrap class="pt-2 pb-3">
        <v-flex xs4 sm3 md2 lg2 class="text-uppercase text-xs-right pr-3 pt-1">Attachments</v-flex>
        <v-flex xs8 sm9 md10 lg10 class="attachment-list">
          <span v-for="(att, idx) in attachments" :key="idx">
            <v-tooltip bottom>
              {{att.filename}}
              <v-chip disabled small outline slot="activator">
                <a :href="auth.decorate_path_with_access_params(att.download_url)" target="attachments">
                  {{att.filename.substr(0,15)}} | {{att.filesize | toFileSize}}
                </a>
              </v-chip>
            </v-tooltip>
          </span>
        </v-flex>
      </v-layout>

    </v-card>

    <v-card class="mb-3">
      <v-layout row>
        <v-flex xs12 ma-3 ref="emailBody">
          <div class="pl-2 body" v-html="email.attributes.body" v-if="email.attributes.is_html"></div>
          <div class="pl-2 body" v-else>{{email.attributes.body}}</div>
        </v-flex>
      </v-layout>

      <v-divider/>

      <v-layout row>
        <v-flex xs12 sm3 lg2 ma-3 v-for="(att, idx) in (email.attributes.attachments)" :key="idx" class="attachment ma-1 pa-1 text-xs-center text-truncate text-nowrap caption">
          <a :href="auth.decorate_path_with_access_params(att.download_url)" target="attachments">
            <v-img
              v-if="att.content_type.includes('image')"
              class="hidden-xs-only mb-2"
              height=100
              contain
              :src="auth.decorate_path_with_access_params(att.preview_url)"
            />
            <v-icon size=120 class="hidden-xs-only" v-else>attachment</v-icon>
            <br>
            <span class="pt-2">
              {{att.filename}}
              <br>
              {{att.filesize | toFileSize}}
            </span>
          </a>
        </v-flex>
      </v-layout>
    </v-card>

    <v-dialog
      :fullscreen="$vuetify.breakpoint.xsOnly"
      v-model="newTicket"
      max-width="65%"
      persistent
      >
      <ticketNew :project="project" :boards="projectBoards" :statuses="projectStatuses" :members="currentProjectMembers" :email="email"></ticketNew>
    </v-dialog>

    <v-dialog
      :fullscreen="$vuetify.breakpoint.xsOnly"
      v-model="linkTicket"
      max-width="65%"
      persistent
      >
      <ticketLink :project="project" :email="email"></ticketLink>
    </v-dialog>
  </div>
</template>

<script>
  import { EventBus } from '@/utilities/event-bus'
  import authentication from '@/utilities/authentication'
  import permissions from '@/utilities/permissions'

  import emailService from '@/services/email'
  import projectService from '@/services/project'
  import statusService from '@/services/status'
  import boardService from '@/services/board'
  import memberService from '@/services/member'
  import ticketService from '@/services/ticket'

  import ticketNew from '@/components/ticket/_new'
  import ticketLink from '@/components/email/_link'

  export default {
    name: 'email-show',

    components: {
      ticketNew: ticketNew,
      ticketLink: ticketLink
    },

    props: ['id', 'projectId'],

    data () {
      return {
        auth: authentication,
        permit: permissions,
        email: null,
        tickets: [],
        project: null,
        projectBoards: [],
        projectStatuses: [],
        projectMembers: [],

        // dialogs
        newTicket: false,
        linkTicket: false,

        fab: false,
        scroll: 0,
        search: '',
        watch: null,
        allEmailsLoaded: false
      }
    },

    computed: {
      stickyClass () {
        if (window.innerWidth > 599) {
          if (this.scroll > 0) {
            return 'elevation-8'
          } else {
            return ''
          }
        }
      },

      attachments () {
        if (this.email) {
          return this.email.attributes.attachments.sort((a, b) => a.filename.localeCompare(b.filename))
        } else {
          return []
        }
      },

      currentProjectMembers () {
        if (this.projectMembers.length > 0) {
          return this.projectMembers.filter(m => !m.attributes.discarded_at)
        } else {
          return []
        }
      },

      emailBody () {
        return this.$refs.emailBody.$el.innerHTML
      }
    },

    async mounted () {
      await this.loadEmail()
      this.loadProject()

      EventBus.$on('ticket-created', (payload) => {
        // close the dialog
        this.newTicket = false
        if (payload) {
          this.tickets.push(Object.assign({}, payload))
        }
      })

      EventBus.$on('ticket-linked', (payload) => {
        // close the dialog
        this.linkTicket = false
        if (payload) {
          if (!this.tickets.find(t => parseInt(t.id) === parseInt(payload.id))) {
            this.tickets.push(Object.assign({}, payload))
          }
        }
      })

      EventBus.$on('ticket-unlinked', (payload) => {
        // close the dialog
        this.linkTicket = false
        if (payload) {
          let idx = this.tickets.findIndex(t => parseInt(t.id) === parseInt(payload.id))
          if (idx >= 0) {
            this.tickets.splice(idx, 1)
          }
        }
      })
    },

    watch: {
    },

    methods: {
      loadEmail () {
        return emailService.projectShow(
          async (data) => {
            this.email = Object.assign({}, data)
            this.loadTickets()
          },
          (err) => {
            console.log(err)
          },
          this.projectId,
          this.id
        )
      },

      loadTickets () {
        ticketService.emailIndex(
          (data) => {
            this.tickets = data
          },
          (err) => {
            console.log(err)
          },
          this.projectId,
          this.email.id
        )
      },

      loadProject () {
        projectService.show(
          async (data) => {
            this.project = Object.assign({}, data)
            EventBus.$emit('project-context', data.id)
            await Promise.all([
              this.loadProjectBoards(),
              this.loadProjectStatuses(),
              this.loadProjectMembers()
            ])
          },
          (err) => {
            console.log(err)
          },
          this.email.relationships.project.data.id
        )
      },

      loadProjectBoards () {
        return boardService.projectIndex(
          (data) => {
            this.projectBoards = data.filter(brd => !brd.attributes.archived)
            this.projectBoards.sort((a, b) => { return a.attributes.name.toLowerCase().localeCompare(b.attributes.name.toLowerCase()) })
          },
          (err) => {
            console.log(err)
          },
          this.project.id
        )
      },

      loadProjectStatuses () {
        return statusService.projectIndex(
          (data) => {
            this.projectStatuses = data.sort((a, b) => { return parseInt(a.position) - parseInt(b.position) })
          },
          (err) => {
            console.log(err)
          },
          this.project.id
        )
      },

      loadProjectMembers () {
        return memberService.projectIndex(
          (data) => {
            this.projectMembers = data.sort((a, b) => { return (a.attributes.name || a.attributes.email).localeCompare(b.attributes.name || b.attributes.email) })
          },
          (err) => {
            console.log(err)
          },
          this.project.id
        )
      }
    }
  }
</script>

<style lang="scss" scoped>
  .v-speed-dial {
    bottom: 100px;
    right: 72px;

    .v-speed-dial__list .v-tooltip {
      display: block;
      margin: 0 auto;
    }
  }

  @media screen and (min-width: 600px) {
    .sticky-element{
      position: sticky;
      position: -webkit-sticky;
      top: 65px;
      z-index: 5;
    }
  }

  .attachment-list {
    max-height: 4.3em;
    overflow-y: scroll;
  }

  .attachment {
    border: 1px solid #d3d3d3;
  }

  .body {
    white-space: pre-wrap;
    overflow: scroll;
  }

</style>



// WEBPACK FOOTER //
// src/components/email/show.vue